import { useLazyQuery } from '@apollo/client';

import GetContractNotesQuery from '@/graphql/contracts/getContractNotes.query.gql';
import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';
import { GetContractNotes, GetContractNotesVariables } from '@/graphql/contracts/_generated_/getContractNotes.query';
import { CONTRACT_NOTES_PER_PAGE } from '@/config/common.config';

type GetContractNotesDto = Omit<GetContractNotesVariables, 'pageSize'>;

export function useGetContractNotes() {
  const [_getContractNotes, { loading, data, called }] = useLazyQuery<GetContractNotes, GetContractNotesVariables>(
    GetContractNotesQuery,
    {
      client: apolloClientContracts,
      fetchPolicy: 'network-only',
    }
  );

  const getContractNotes = (dto: GetContractNotesDto) => {
    _getContractNotes({
      variables: {
        pageSize: CONTRACT_NOTES_PER_PAGE,
        ...dto,
      }
    });
  };

  return {
    getContractNotes,
    notesData: data?.contract.contractNotes,
    isLoading: loading,
    isCalled: called,
  } as const;
}
